export default __webpack_public_path__ + "static/media/new-floor-2.a14aab9f.svg";